export default __webpack_public_path__ + "static/media/6.2689d42c.jpg";